import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { MsalAuthenticationService } from '../../../services/common-auth/msalauthentication.service';
import { TranslateService } from '@ngx-translate/core';
import { LayoutService } from '../../../services/layout/layout.service';
import { SessionStorageService } from 'angular-web-storage';
import { IErrorState } from '../../../shared/models';
import { BaseConstantService } from '../../../services/constant/base-constant.service';
import { Meta } from '@angular/platform-browser';

const errorHeaderLabel = 'Shared.lblServiceError';
const backButtonLabel = 'Shared.lblBack';
const logoutLabel = 'Shared.lblLogout';

@Component({
  selector: 'lib-link-expired-screen',
  templateUrl: './link-expired-screen.component.html',
  styleUrls: ['./link-expired-screen.component.scss']
})

export class LinkExpiredScreenComponent implements OnInit {

  @Input() fromHomePage: boolean;
  @Input() errorMessageLabelText = 'The link to create your password has expired.';


  errorHeaderLabelText = 'Service Error';
  errorSeconadryMessageLabelText;
  backButtonText = 'Login';
  logoutText = 'Logout';
  isMobile: boolean;
  isDesktop: boolean;
  hideBackButton: boolean;
  state: IErrorState;
  isLoading: boolean;
  hasMultipleSecondaryMessages: boolean;
  isCustomerBlocked = false;

  hasMultipleMessages(): boolean {
    return Array.isArray(this.errorMessageLabelText);
  }

  constructor(
    private msalService: MsalAuthenticationService,
    private router: Router,
    private translate: TranslateService,
    private layoutService: LayoutService,
    private sessionStorage: SessionStorageService,
    private baseConstantService: BaseConstantService,
    private metaTag: Meta,
  ) { }

  async ngOnInit() {
    this.getState();
    this.applyTranslations();
    this.checkDeviceWidth();
  }

  private getState() {
    if (history && history.state) {
      this.state = history.state as IErrorState;
    }
  }

  private hasCustomMessage() {
    return this.state && (this.state.header || this.state.primaryMessage);
  }

  private applyTranslations() {
    this.translate.get([errorHeaderLabel, backButtonLabel, logoutLabel]).subscribe((res) => {
      if (this.hasCustomMessage()) {
        if (this.state.buttonLabel === null || !this.state.buttonLabel) {
          this.state.buttonLabel = res[backButtonLabel];
        }
        this.setErrorHeaderAndMessage(this.state.header, this.state.primaryMessage, this.state.secondaryMessage, this.state.buttonLabel);
      } else {
        this.setErrorHeaderAndMessage(res[errorHeaderLabel], null, null, res[backButtonLabel]);
      }
      if (this.logoutText && this.logoutText !== '' && res[logoutLabel] !== logoutLabel) {
        this.logoutText = res[logoutLabel];
      }
    });
  }

  private setErrorHeaderAndMessage(header, primaryMessage, secondaryMessage, buttonLabel) {
    this.errorHeaderLabelText = header && header !== errorHeaderLabel ? header : this.errorHeaderLabelText;
    this.errorMessageLabelText = (primaryMessage && !this.fromHomePage)
      ? primaryMessage
      : this.errorMessageLabelText;
    this.errorSeconadryMessageLabelText = secondaryMessage;
    this.backButtonText = buttonLabel && buttonLabel !== backButtonLabel ? buttonLabel : this.backButtonText;
    this.hasMultipleSecondaryMessages = Array.isArray(secondaryMessage);
  }

  checkDeviceWidth() {
    this.layoutService.subscribeToLayoutChanges().subscribe(observerResponse => {
      this.isMobile = this.layoutService.isSmallView();
      this.isDesktop = this.layoutService.isLargeView();
    });
  }

  goBack() {
    this.msalService.login();
  }

  logout() {
    this.msalService.logout();
  }
}
